import { MultiselectPopOver } from '@components/UI-Components/MultiselectPopOver'
import { nav } from '@stores/nav'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { TableViewStoreContext } from '../container/StandardTableView'

export interface TableColumnFilterProps {}

export const TableColumnFilter: React.SFC<TableColumnFilterProps> = () => {
  return useObserver(function useHook() {
    const {
      columFilterData,
      getDataToShowInPopOverFilter,
      closeFilterPopOver,
      applyColumnFilter,
      filteredColumns,
      resetFilters
    } = React.useContext(TableViewStoreContext) as any
    const {
      queryParams: { section, view }
    } = nav
    React.useEffect(() => {
      return () => {
        resetFilters?.()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section, view])

    const data = getDataToShowInPopOverFilter()
    const filteredValues = filteredColumns[columFilterData.selectedColumnId]
    return columFilterData.anchorEl ? (
      <MultiselectPopOver
        values={data}
        filteredValues={filteredValues}
        onApply={applyColumnFilter}
        label={columFilterData.selectedColumnName}
        anchorEl={columFilterData.anchorEl}
        onClose={closeFilterPopOver}
        name={columFilterData.selectedColumnId}
        labelKey={columFilterData.selectedLabelKey}
      />
    ) : null
  })
}
